import { z } from 'zod';

export const ProductSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  area_id: z.string().uuid().nullable(),
  item_category_id: z.string().uuid(),
  name: z.string(),
  quantity: z.number(),
  unit: z.string(),
  section_markup_id: z.string().uuid().nullable(),
  notes: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const CreateProductSchema = z.object({
  area_id: z.string().uuid().nullable().optional(),
  item_category_id: z.string().uuid(),
  name: z.string().min(1, 'Product name is required').max(200),
  quantity: z.number().min(0).default(1),
  unit: z.string().default('m²'),
  section_markup_id: z.string().uuid().nullable().optional(),
  notes: z.string().nullable().optional(),
});

export const UpdateProductSchema = z.object({
  area_id: z.string().uuid().nullable().optional(),
  item_category_id: z.string().uuid().optional(),
  name: z.string().min(1).max(200).optional(),
  quantity: z.number().min(0).optional(),
  unit: z.string().optional(),
  section_markup_id: z.string().uuid().nullable().optional(),
  notes: z.string().nullable().optional(),
});

export type Product = z.infer<typeof ProductSchema>;
export type CreateProduct = z.infer<typeof CreateProductSchema>;
export type UpdateProduct = z.infer<typeof UpdateProductSchema>;
